import { useState, useEffect } from 'react';
import { projectId } from '../utils/supabase/info';
import { getAuthHeaders } from '../utils/apiHeaders';

export function useSpaceReviews(accessToken: string) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!accessToken) return;

    const fetchCount = async () => {
      try {
        const response = await fetch(
          `https://${projectId}.supabase.co/functions/v1/make-server-e90c59cd/space-planning/pending-reviews`,
          {
            headers: getAuthHeaders(accessToken),
          }
        );

        if (response.ok) {
          const data = await response.json();
          setCount(data.reviews?.length || 0);
        }
      } catch (error) {
        console.error('Error loading space reviews count:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchCount();
  }, [accessToken]);

  return { count, loading };
}